export const PROMOTION_TYPES = {
  novelty: 'NOVELTY',
  promotion: 'PROMOTION',
  mastercard: 'MASTERCARD',
  visamobile: 'VISAMOBILE',
  blik: 'BLIK',
}
